<template>
  <svg
    height="0"
    width="0"
  >
    <defs>
      <linearGradient
        id="spectreGradient"
        x1="0"
        y1="0"
        x2="800"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stop-color="#b113e8"
        />
        <stop
          offset="0.14285714285714285"
          stop-color="#a21ee7"
        />
        <stop
          offset="0.2857142857142857"
          stop-color="#9325e5"
        />
        <stop
          offset="0.42857142857142855"
          stop-color="#832ae3"
        />
        <stop
          offset="0.5714285714285714"
          stop-color="#722ee0"
        />
        <stop
          offset="0.7142857142857143"
          stop-color="#6030dd"
        />
        <stop
          offset="0.8571428571428571"
          stop-color="#4c33da"
        />
        <stop
          offset="1"
          stop-color="#3434d6"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
</script>
